import { Injectable } from '@angular/core';
import { BaseTemplateMapper } from './base-template-mapper';
import { SampleTemplateMapper } from './entities/sample-template-mapper';
import { SampleSurveyTemplateMapper } from './entities/sample-survey-template-mapper';
import { MultiSampleTemplateMapper } from './entities/multi-sample-template-mapper';
import { RiskRegisterTemplateMapper } from './entities/risk-register-template-mapper';
import { ChainOfCustodyTemplateMapper } from './entities/chain-of-custody-template-mapper';
import { ENTITY_TYPES } from 'src/app/shared/widget-registry';

@Injectable({
  providedIn: 'root'
})
export class TemplateMapperRegistry {
  private mappers = new Map<string, BaseTemplateMapper>();

  constructor(
    private sampleMapper: SampleTemplateMapper,
    private sampleSurveyMapper: SampleSurveyTemplateMapper,
    private multiSampleMapper: MultiSampleTemplateMapper,
    private riskRegisterMapper: RiskRegisterTemplateMapper,
    private chainOfCustodyMapper: ChainOfCustodyTemplateMapper
  ) {
    this.registerMappers();
  }

  private registerMappers(): void {
    this.mappers.set(ENTITY_TYPES.SAMPLE, this.sampleMapper);
    this.mappers.set(ENTITY_TYPES.SAMPLE_SURVEY, this.sampleSurveyMapper);
    this.mappers.set(ENTITY_TYPES.MULTI_SAMPLE, this.multiSampleMapper);
    this.mappers.set(ENTITY_TYPES.RISK_REGISTER, this.riskRegisterMapper);
    this.mappers.set(ENTITY_TYPES.EMPLOYEE_LETTER, this.sampleMapper);
    this.mappers.set(ENTITY_TYPES.CHAIN_OF_CUSTODY, this.chainOfCustodyMapper);
  }

  /**
   * Get mapper for specific entity type
   */
  getMapper(entityType: string): BaseTemplateMapper | undefined {
    return this.mappers.get(entityType);
  }

  /**
   * Get all available entity types
   */
  getAvailableEntityTypes(): string[] {
    return Array.from(this.mappers.keys());
  }

  /**
   * Check if mapper exists for entity type
   */
  hasMapper(entityType: string): boolean {
    return this.mappers.has(entityType);
  }
}
